import intlTelInput from 'intl-tel-input';

export function createIntlTelInput(element, options) {
  return intlTelInput(element, options);
}
